


import React from 'react';
import AccesoriesFilter from './AccesoriesFilter'; // Assuming this is your filter component
import AccesoriesRelevance from '../Accesories/AccesoriesRelevance';

function AccesoriesComponent() {
  return (
    <div className="min-h-screen flex flex-row p-12 gap-8">
      {/* First section taking 25% width (can be left empty) */}
      <div className="w-1/4">
      <AccesoriesFilter/> </div>

      {/* Second section taking 75% width */}
      <div className="w-3/4">
        <AccesoriesRelevance />
      </div>
    </div>
  );
}

export default AccesoriesComponent;
